<template>
  <div @click="topFunction()" id="scrollTopBtn">
    <div class="icon-up"></div>
  </div>
</template>
<script>
  // When the user scrolls down 20px from the top of the document, show the button
  window.onscroll = function () {
    scrollFunction()
  };

  function scrollFunction () {
    let ele = document.getElementById('scrollTopBtn');
    if (!ele) {
      return;
    }
    if (document.body.scrollTop > 180 || document.documentElement.scrollTop > 180) {
      document.getElementById('scrollTopBtn').style.display = 'block';
    } else {
      document.getElementById('scrollTopBtn').style.display = 'none';
    }
  }

  export default {
    name: 'scrollTop',
    methods: {
      // When the user clicks on the button, scroll to the top of the document
      topFunction () {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  #scrollTopBtn {
    position: relative;
    bottom: 0;
    /* left: 0px; */
    top: 9px;
    right: 27px;
    z-index: 99;
    border: none;
    cursor: pointer;
    width: 27px;
    height: 27px;
    .icon-up{
      margin: 1.5px 1.5px;
      width: 27px;
      height: 27px;
      color: @light-blue;
      background-color: @light-blue;
      -webkit-mask: url('../../../static/img/up-circle.svg') no-repeat center;
      mask: url('../../../static/img/up-circle.svg') no-repeat center;
      background: url('../../../static/img/up-circle-blue.svg');
    }
  }
  /*#scrollTopBtn:hover {
    background-color: #555; !* Add a dark-grey background on hover *!
  }*/
</style>



// WEBPACK FOOTER //
// ScrollTop.vue?1effd236